import CryptoJS from "crypto-js";
import Lottie from "lottie-react";
import { useEffect, useState } from "react";
import { Col, Container, Form, Popover, Row } from "react-bootstrap";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import { useNavigate } from "react-router-dom";
import { ApiServices } from "../../app/base/service/apiService";
import { util, validator } from "../../app/base/utils";
import { AutoService } from "../../service/auto";
import { LoginService } from "../../service/login";
import { API_ROUTE_CONTROLLER } from "../../service/route";
import gray from "../../styles/images/dimond_bullet_gray.svg";
import red from "../../styles/images/dimond_bullet_red.svg";
import worktualLoader from "../../styles/images/worktual-loader.json";
import styles from "./scss/audracare_onboarding.module.scss";

const ls = new LoginService();
const as = new AutoService();

const AudraCareOnboarding = () => {
  const navigate = useNavigate();
  const [pageLoader, setPageLoader] = useState(true);
  const [hideContinue, setHideContinue] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [strength, setStrength] = useState<any>(false);
  const [uppercase, setUppercase] = useState(false);
  const [max8, setMax8] = useState(false);
  const [numeric1, setNumeric1] = useState(false);
  const [checkBoxSet, setCheckBoxSet] = useState(false);
  const [orderdata, setOrderData] = useState<any>([]);
  console.log("userdata", orderdata);
  const currentUrl = window.location.href;
  console.log("currentUrl", currentUrl)
  const [domainID, setDomainID] = useState("");

  const [getPasswordText, setPasswordText] = useState("");
  const [getConfirmPasswordText, setConfirmPasswordText] = useState("");

  let intialValues = {
    password: "",
  };

  const [formErrors, setFormErrors] = useState<any>({});
  console.log("formErrors", formErrors)
  const [formValues, setFormValues] = useState<any>(intialValues);

  const [companyId, setCompanyID] = useState<any>("");
  const [orderId, setOrderId] = useState<any>("");


  const submitForm = () => {
    if (Object.keys(formErrors).length == 0) {
      return false;
    }

    let flag = true;
    let hasFalse = Object.keys(formErrors).some((keyName) => {
      if (formErrors[keyName]) {
        flag = false;
      }
    });
    return flag;
  };

  const handleSubmit = async (e: any) => {
    // setPageLoader(true)
    setFormErrors(validate(formValues));
    e.preventDefault();
    // insertonboardingLink(2)
    if (submitForm()) {
      console.log("submitform")
      setHideContinue(true)
      companyorderInfo(orderId);
    }
  };

  const getStrength = () => {
    if (strength == 0) return "Poor";
    if (strength == 1) return "Weak";
    if (strength == 2) return "Medium";
    if (strength == 3) return "Strong";
  };

  const validate = (values: any) => {
    const errors: any = {};
    var ob: any = new validator();
    var ob1: any = new validator();
    errors.password = ob
      .set(values.password)
      .password_8("Minimum 8 characters")
      .password_numeric("At least 1 number")
      .password_upper("At least 1 uppercase letter")
      .required("Password is required").msg;
    errors.confirmPassword = ob1
      .set(values.confirmPassword)
      .password_match(
        "passwords do not match",
        formValues.password,
        formValues.confirmPassword
      )
      .required("passwords do not match").msg;
    setStrength(ob.strong);
    setUppercase(ob.one_upper == 1 ? true : false);
    setMax8(ob.max_8 == 1 ? true : false);
    setNumeric1(ob.one_numeric == 1 ? true : false);
    return errors;
  };

  const handleChange = (e) => {
    formValues.password = e.target.value;
    let _errors = validate(formValues);
    setFormErrors(_errors);
  };

  const handleChangeReEnter = (e) => {
    formValues.confirmPassword = e.target.value;
    if (formValues.password == formValues.confirmPassword) {
      let _errors = validate(formValues);
      setPasswordText(formValues.password);
      setFormErrors(_errors);
    } else {
      let _errors = validate(formValues);
      setFormErrors(_errors);
    }
  };

  const companyorderInfo = async (orderId: any) => {
    let urlcare = API_ROUTE_CONTROLLER.companyorderInfo;

    let bodyCare = {
      comp_user_id: orderId,
    };

    await ApiServices.post(bodyCare, urlcare).then(async (value: any) => {
      console.log("valuee-->>", value);
      if (value.data.statusCode == 0) {
        setOrderData(value.data.result[0]);
        let userData = value.data.result[0]
        await careHomeOnBoardInsert(userData);
        insertCompany(userData);
      }
    });
  };

  const key = `carehome-crypto`;

  const encrypt = (text: any) => {
    const encrypted = CryptoJS.AES.encrypt(text, key).toString();

    return encrypted;
  };

  const careHomeOnBoardInsert = async (userData) => {
    let urlcare = API_ROUTE_CONTROLLER.carehomeonboardinsert;
    let bodyCare = {
      companyId: companyId,
      domainId: domainID,
      companyName: userData?.company_name,
      email: userData?.email,
      contactPhone: userData?.mobileno,
      address1: "",
      address2: "",
      address3: "",
      city: userData?.city,
      country: "",
      companyLogo: "",
      ODSCode: "",
      adminFirstName: userData?.first_name,
      adminSurName: userData?.last_name,
      password: getPasswordText,
    };
    const encryptedData = encrypt(JSON.stringify(bodyCare));

    console.log("body-->>", bodyCare)
    return await ApiServices.post(encryptedData, urlcare).then(
      async (value: any) => {
        console.log("valuee-->>", value);
      }
    );
  };

  const insertCompany = async (userData) => {
    let urlcare = API_ROUTE_CONTROLLER.InsertCompany;

    let bodyCare = {
      p_resellerId: 1005,
      p_companyId: companyId,
      p_planId: userData.plan_id,
      p_plan_duration: userData.Duration,
      p_total_plan_user: userData.Users,
      p_total_plan_user_purchase: userData.Users,
      p_plan_price: userData.plan_ind_amount,
      p_bill_cycle: 0,
      p_Is_free_trail: 0,
      p_Is_FT_to_paid: 0,
      isChatBot: "1"
    };

    console.log("body2", bodyCare)

    //const encryptedData = encrypt(JSON.stringify(bodyCare));

    await ApiServices.post(bodyCare, urlcare).then(async (value: any) => {
      console.log("valuee-->>", value);
      if (value.data.result[0][0].errcode == 0) {
        insertonboardingLink(companyId);

        // setOrderData(value.data.result[0]);

      }
    });
  };

  const insertonboardingLink = (companyId) => {
    const url = API_ROUTE_CONTROLLER.insert_onboarding_link;
    // const url = `https://qacarehomeapi.audracare.co.uk/homecare_service/v1/insert_onboarding_link`;
    const body = {
      "companyId": companyId,
      "link": currentUrl,
      "isChatBot": "1"
    }
    ApiServices.post(body, url).then((res) => {
      console.log("insertRes", res)

      if (res?.data && res?.status) {
        window.location.href = "https://carehome.audracare.co.uk/login";
      }
    }).catch(() => {

    })
  }

  // useEffect(()=>{
  //   if(orderdata.length > 0 && domainID){
  //     careHomeOnBoardInsert();
  //     insertCompany();
  //   }
  // },[orderdata,domainID])

  const getOnboardLink = (companyId) => {

    const url = `${API_ROUTE_CONTROLLER.get_onboarding_link}/${companyId}`;
    // const url = `https://qacarehomeapi.audracare.co.uk/homecare_service/v1/get_onboarding_link/6`;

    ApiServices.get(url).then((res) => {
      console.log("res", res)
      if (res?.data?.statusCode == 200 && res?.data?.message == "success") {
        window.location.href = "https://carehome.audracare.co.uk/login";

      } else {
        setPageLoader(false)
      }
    }).catch(() => {

    })

  }

  useEffect(() => {
    document.title = "Audra Care"
    const _temp_url = window.location.href.replace("?", "?&").split("?");
    const params = new URLSearchParams(window.location.href.replace("?", "?&"));

    const encodedOrderId = params.get("ordID");
    const encodedOrderId2 = params.get("userid");
    const encodedOrderId3 = params.get("company_id");
    if (encodedOrderId && encodedOrderId2) {
      const orderId = util.base64_decode(encodedOrderId);
      const domainID_ = util.base64_decode(encodedOrderId2);
      const companyId = util.base64_decode(encodedOrderId3);
      console.log("Ids", orderId, domainID_, companyId);
      setOrderId(orderId)
      setCompanyID(companyId);
      setDomainID(domainID_)
      getOnboardLink(companyId);

    }
  }, []);

  return (<>
    {pageLoader ? (
      <div className={styles.mainloader}>
        <Lottie
          style={{ width: 100, margin: "0 auto" }}
          animationData={worktualLoader}
        />
      </div>
    ) : (
      <form id="frm" name="frm" method="post" onSubmit={handleSubmit}>
        <>
          {!hideContinue ? (
            <Container fluid className={styles.loginscreen}>
              <div className={`${styles.signinform} ${styles.loginformdiv}`}>
                <Row className={styles.rowright}>
                  <Col sm={12} md={6} lg={6} className={styles.whitebox}>
                    <div className={styles.innerconsec}>
                      <Form.Group controlId="exampleForm.ControlTextarea1">
                        <div className={styles.logincontainersec}>
                          <div className={styles.loginformsection}>
                            <h4 className={styles.signtopsec}>Open Sesame</h4>
                            <p>
                              Come in, come in. Your account is now active and
                              just choose your magic words.
                            </p>
                            <h5>Create a password</h5>
                          </div>
                          <div
                            className={`onboardpopover ${styles.logformvalid}`}
                          >
                            <div className={styles.inputfield}>
                              <OverlayTrigger
                                trigger="focus"
                                placement={
                                  windowWidth <= 767 ? "bottom" : "bottom"
                                }
                                overlay={
                                  <Popover
                                    id="popover-basic"
                                    className="onboardpopover1"
                                  >
                                    <Popover.Header as="h3">
                                      <span className={styles.charactersize}>
                                        {getStrength()}
                                      </span>
                                    </Popover.Header>
                                    <Popover.Body>
                                      <ul>
                                        <li>
                                          {!max8 ? (
                                            <>
                                              <img src={red} /> <span></span>At
                                              least 8 Characters
                                            </>
                                          ) : (
                                            <>
                                              <img src={gray} alt="del" />{" "}
                                              <span></span>
                                              <del>At least 8 Characters</del>
                                            </>
                                          )}
                                        </li>
                                        <li>
                                          {!uppercase ? (
                                            <>
                                              <img src={red} />
                                              <span></span> At least 1 uppercase
                                              letter
                                            </>
                                          ) : (
                                            <>
                                              <img src={gray} alt="del" />{" "}
                                              <span></span>
                                              <del>
                                                At least 1 uppercase letter
                                              </del>
                                            </>
                                          )}
                                        </li>
                                        <li>
                                          {!numeric1 ? (
                                            <>
                                              <img src={red} />
                                              <span></span> At least 1 number
                                            </>
                                          ) : (
                                            <>
                                              <img src={gray} alt="del" />{" "}
                                              <span></span>
                                              <del>At least 1 number</del>
                                            </>
                                          )}
                                        </li>
                                      </ul>
                                    </Popover.Body>
                                  </Popover>
                                }
                              >
                                <Form.Control
                                  type={getPasswordText}
                                  className={
                                    formErrors.password
                                      ? `${styles.forminputsec} ${styles.errorshow}`
                                      : `${styles.forminputsec}`
                                  }
                                  name="password"
                                  value={formValues.password}
                                  onChange={handleChange}
                                  autoComplete="off"
                                  maxLength={15}
                                  placeholder="Password"
                                  onPaste={(e) => {
                                    e.preventDefault();
                                    return false;
                                  }}
                                  onCopy={(e) => {
                                    e.preventDefault();
                                    return false;
                                  }}
                                />
                              </OverlayTrigger>

                              {getPasswordText === "text" ? (
                                <span
                                  className={styles.eyesiconslash}
                                  onClick={(e) => {
                                    setPasswordText("password");
                                  }}
                                ></span>
                              ) : (
                                <span
                                  className={styles.tickchecks}
                                  onClick={(e) => {
                                    setPasswordText("text");
                                  }}
                                ></span>
                              )}
                            </div>
                            {formErrors.password && (
                              <span className={styles.errormsg}>
                                {formErrors.password}
                              </span>
                            )}
                            <div className={`${styles.inputfield}`}>
                              {/* <label>Confirm the new password</label> */}
                              <Form.Control
                                className={
                                  formErrors.confirmPassword
                                    ? `${styles.forminputsec} ${styles.errorshow}`
                                    : `${styles.forminputsec}`
                                }
                                name="confirmPassword"
                                type={getConfirmPasswordText}
                                value={formValues.confirmPassword}
                                placeholder="Re-enter password"
                                autoComplete="off"
                                maxLength={15}
                                onChange={handleChangeReEnter}
                                onPaste={(e) => {
                                  e.preventDefault();
                                  return false;
                                }}
                                onCopy={(e) => {
                                  e.preventDefault();
                                  return false;
                                }}
                              />
                              {/* {
                                getConfirmPasswordText === 'text' ?
                                  <span className={styles.eyesiconslash} onClick={(e) => { setConfirmPasswordText('password') }}></span>
                                  :
                                  <span className={`${styles.tickchecks}`} onClick={(e) => { setConfirmPasswordText('text') }}></span>
                              } */}
                            </div>
                            <p>
                              {formErrors.confirmPassword && (
                                <span className={`${styles.errormsg}`}>
                                  {formErrors.confirmPassword}
                                </span>
                              )}
                            </p>

                            <div className={styles.pwdcheckbox}>
                              <div className={styles.view}>
                                <div className={styles.left}>
                                  <input
                                    type="checkbox"
                                    onClick={() => {
                                      setCheckBoxSet(!checkBoxSet);
                                    }}
                                  />
                                </div>
                                <div className={styles.right}>
                                  {" "}
                                  <span>
                                    By clicking on "Let's get started", you are
                                    agreeing to Audracare's{" "}
                                    <a
                                      href="https://audracare.co.uk/privacy-policy/"
                                      target="_blank"
                                    >
                                      Terms and Conditions
                                    </a>
                                    .
                                  </span>
                                </div>
                              </div>
                            </div>

                            <div className={styles.getstartbtn}>
                              <input
                                className={
                                  formValues?.confirmPassword?.length > 0 &&
                                    formValues?.password?.length > 0 &&
                                    checkBoxSet === true && max8 && uppercase && numeric1 && submitForm()
                                    ? `${styles.forminputsec} ${styles.signbtn} `
                                    : `${styles.forminputsec} ${styles.signbtn} ${styles.disable}`
                                }
                                type="submit"
                                value="Let’s get started"
                              />
                            </div>
                          </div>
                        </div>
                      </Form.Group>
                    </div>
                  </Col>
                </Row>
              </div>
            </Container>
          ) : (
            <Container fluid>
              <div className={styles.loaderscreen}>
                <h3>Hi</h3>
                <p>
                  Behind the scenes we’re organizing your{" "}
                  <span>
                    <b>account settings</b>
                  </span>
                  .<br />
                  Best go grab a cuppa. (Although, by the time you read this we’ll
                  probably be done)
                </p>
                {/* <Lottie className={styles.lotties} animationData={generaljson} /> */}
              </div>
            </Container>
          )}
        </>
      </form>
    )}
  </>)
};
export default AudraCareOnboarding;
